/**
 * Rollbar error tracking - Removed for static content site
 * These are no-op stubs to maintain API compatibility
 */

export const setup = () => {}
export const setUser = () => {}
export const handlePageChange = () => {}
